import { formatFieldValue } from '../../utils/formatFieldValue'
import type { PlayerDetailsFieldDef, PlayerDetailsFormValues } from '../types'

const trimmed = (value: unknown): string =>
  value === null || value === undefined ? '' : String(value).trim()

/**
 * The read-mode text for one field, or `null` when it has no value (the view
 * renders its own empty marker).
 *
 * - height → "5 ft 10 in", from the ft/in pair
 * - everything else → `formatFieldValue` (shared with the Edit Player read
 *   mode): switch Yes / No, select label, short date, value + unit
 */
export const formatDetailValue = (
  def: PlayerDetailsFieldDef,
  values: PlayerDetailsFormValues
): string | null => {
  if (def.kind === 'height') {
    const ft = trimmed(values.heightFt)
    const inches = trimmed(values.heightIn)
    if (!ft && !inches) {
      return null
    }
    return `${ft || '0'} ft ${inches || '0'} in`
  }

  return formatFieldValue(def.kind, values[def.name], def)
}
